module.exports = __webpack_public_path__ + "web_static/img/20201119174424.bd80a635.gif";